<template>
    <!-- 批量寄件,收件人列表 -->
    <div class="sender">
        <cus-field
                type="search"
                wrap-background="#fff"
                input-background="#F1F1F1"
                placeholder="请输入姓名/电话/地址"
                @input="handleSearchInput"
                v-model="params.params.query"
        ></cus-field>
        <div class="sender_list_box">
          <van-list class="address-list__box body-padding" v-model="loading" :finished="finished" @load="getList"
                    finished-text="没有更多了"
                    error-text="请求失败，点击重新加载">
            <div class="send-address-card" :class="{ 'send-address-card__active': item.check }" v-for="(item,index) in list"
                 :key="index">
                <div class="card-row">
                    <div class="card-col">
                        <div class="font-detail">{{ item.name }} {{ item.concatPhone }}</div>
                        <div class="font-info info-address">{{ item.provinceName + item.cityName + item.districtName +
                            item.clothingCityName + item.address }}
                        </div>
                    </div>
                    <div class="card-col check-btn font-info" @click="handleCheck(index)">
                        <div class="select-btn" :class="{ 'select-btn__active': item.check }">确认选择</div>
                    </div>
                </div>
                <template v-if="check">
                    <div class="card-row">

                    </div>
                </template>
                <div class="card-row">
                    <div class="card-col f-row">
                        <!--					<div class="select-btn-left"-->
                        <!--					:class="{ 'select-btn-left__active': item.addressDefault && item.addressDefault.toString() === '1' }"-->
                        <!--					@click="handleSetDefaultClick(index)">-->
                        <!--						设为默认-->
                        <!--					</div>-->
                        <div class="btn-box">
                            <div class="edit-btn" @click="handleEditClick(item)"></div>
                            <div class="del-btn" @click="handleDelClick(item)"></div>
                        </div>
                    </div>
                </div>
            </div>
          </van-list>
        </div>
        <div class="btn-box-affirm">
            <van-button to="/acceptAddress/add" class="btn" round type="warning">新增收件人</van-button>
            <van-button class="btn" round type="warning" @click="handleAddressConfirm">确认</van-button>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: 'Recipients',
        data() {
            return {
                params: {
                    params: {
                        addressType: 2,
                        query: ''
                    },
                    page: {
                        pageNum: 1,
                        pageSize: 10
                    }
                },
                timeout: null,
                list: [],
                check: false,
                value: '',
                choice: this.$route.query.choice,
                loading: false,
                finished: false
            };
        },
        computed: {
            ...mapState({
                acceptList: state => state.acceptList,
                acceptLists: state => state.acceptLists
            })
        },
        mounted() {
            //this.getList()
        },
        methods: {
            handleSearchInput() {
                clearTimeout(this.timeout);
                this.params.page.pageNum = 1;
                this.timeout = setTimeout(() => {
                    this.getList(true)
                }, 500)
            },
            getList(isSearch) {
                this.$axios.post('merchant/getPageAddressByType', this.params).then(res => {
                    let data = res.data.data
                    if(isSearch) {
                      this.list = data.list
                    } else {
                      this.list = [...this.list, ...data.list]
                    }
                    if (this.list.length === 0) return
                    if (this.list[0].addressDefault == 1) {
                        this.list[0].goodsNumber = ''
                        let list = [this.list[0]]
                        for (let i = 0; i < this.list.length; i++) {
                            for (let j = 0; j < this.acceptList.length; j++) {
                                if (this.acceptLists[j].id == this.list[i].id) {
                                    this.list[i].check = true
                                }
                            }
                            for (let j = 0; j < this.acceptLists.length; j++) {
                                if (this.acceptLists[j].id == this.list[i].id) {
                                    this.list[i].check = true
                                }
                            }
                        }
                    } else {
                        this.list[0].goodsNumber = ''
                        let list = [this.list[0]]
                        for (let i = 0; i < this.list.length; i++) {
                            for (let j = 0; j < this.acceptList.length; j++) {
                                if (this.acceptLists[j].id == this.list[i].id) {
                                    this.list[i].check = true
                                }
                            }
                            for (let j = 0; j < this.acceptLists.length; j++) {
                                if (this.acceptLists[j].id == this.list[i].id) {
                                    this.list[i].check = true
                                }
                            }
                        }
                    }
                    this.params.page.pageNum++;
                    this.finished = !data.hasNextPage;
                })
                .catch(err => {
                  this.error = true;
                })
                .finally(() => {
                  this.loading = false;
                });
            },
            // 选择
            handleCheck(index) {
                if (this.choice == true) {
                    if (this.list[index].check == true) {
                        this.list[index].check = false
                        this.check = !this.check
                        return
                    }
                    for (let i = 0; i < this.list.length; i++) {
                        if (this.list[i].check) {
                            this.list[i].check = false
                        }
                    }
                    this.list[index].check = true
                    this.check = !this.check
                } else {
                    if (this.list[index].check == true) {
                        this.list[index].check = false
                    } else {
                        this.list[index].check = true
                    }
                    this.check = !this.check
                }


            },
            // 默认
            handleSetDefaultClick(index) {
                let id = this.list[index].id
                this.list.forEach(item => {
                    item.addressDefault = 0
                })
                this.list.forEach(item => {
                    if (item.id == id) {
                        item.addressDefault = 1
                    }
                })

                let params = {
                    params: {
                        addressType: 2,
                        id: id
                    }
                };
                this.$axios.post('merchantConcat/setAddressDefault', params).then(res => {
                    if (res.data.code === 200) {
                        // this.loading = true;
                        // this.list.splice(0, this.list.length);
                        // this.finished = false;
                        // this.params.page.pageNum = 1;
                        // this.getList();
                    }
                });
            },
            // 修改
            handleEditClick(item) {
                let check = this.list.filter(val => val.check)
                this.$store.commit('confirmSend', check)
                this.$router.push("/acceptAddress/modify/" + item.id)
            },
            // 删除
            handleDelClick(item) {
                this.$dialog.confirm({
                    title: '温馨提示',
                    message: '是否确认删除该地址'
                }).then(() => {
                    let params = {
                        params: item.id
                    };
                    this.$axios.post("merchantConcat/removeAddress", params).then(() => {
                        if (item.check) {
                            this.$store.commit('uncheckSend', item)
                        }
                        this.list.splice(0, this.list.length);
                        this.params.page.pageNum = 1;
                        this.loading = true;
                        this.finished = false;
                        this.getList()
                    });
                }).catch(err => {
                    this.$toast({
                        message: err.data.msg,
                        duration: 1000
                    })
                });
            },
            handleAddressConfirm() {
                let data = []
                for (let i = 0; i < this.list.length; i++) {
                    if (this.list[i].check == true) {
                        data.push(this.list[i])
                    }
                }
                if (data.length == 0) {
                    this.$toast({
                        message: '请选中收件人!',
                        duration: 1000
                    });
                    return;
                }
                if (data.length > 1) {
                    for (let i = 0; i < data.length; i++) {
                        data[i].valueText = ''
                        data[i].con = true
                        data[i].goodsNumber = ''
                    }
                } else if (data.length == 1) {
                    data[0].goodsNumber = ''
                }
                this.$store.commit('confirmAccepts', data)
                this.$router.go(-1)
            },
        },
        created() {
            //this.getList()
        },
    }
</script>

<style lang="less" scoped>
    .sender {
        padding: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .sender_list_box {
            padding: 0 0.27rem;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            box-sizing: border-box;
            flex: 1;
        }
    }

    .font-info {
        color: #8f8f8f;
        font-size: 0.32rem;
    }

    .font-detail {
        color: #2e2e2e;
        font-size: 0.4rem;
    }

    .send-address-card {
        background-color: #fff;
        color: #4f4f4f;
        font-size: 0.35rem;

        & ~ .send-address-card {
            margin-top: 0.13rem;
        }

        &__active {
            background-color: #d3e4ff;
        }
    }

    .info-address {
        max-height: 0.65rem;
        line-height: 0.35rem;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .card-row {
        display: flex;
        flex-direction: row;
        position: relative;

        & ~ .card-row {
            &:before {
                content: '';
                position: absolute;
                width: 90%;
                border-top: 1px solid #e5e5e5;
                left: 50%;
                top: 0;
                transform: translateX(-50%);
            }
        }

        .card-col {
            padding: 0.15rem 0.48rem;
            flex: 1;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            &.f-row {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            & ~ .card-col {
                &:before {
                    content: '';
                    position: absolute;
                    height: 80%;
                    border-left: 1px solid #e5e5e5;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0;
                }
            }
        }
    }

    .check-btn {
        flex: unset !important;
        width: 2.79rem;
        box-sizing: border-box;

        .select-btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .select-btn {
        text-align: right;
        position: relative;
        padding-right: 0.5rem;

        &.select-btn__active {
            color: #2e2e2e;

            &:after {
                background: url('../../../assets/btn-checked.png') center/100% no-repeat;
            }
        }

        &:after {
            content: '';
            background: url('../../../assets/btn-unChecked.png') center/100% no-repeat;
            width: 17px;
            height: 17px;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            position: absolute;
        }

        &-left {
            position: relative;
            padding-left: 0.42rem;

            &.select-btn-left__active {
                &:after {
                    background: url('../../../assets/btn-checked_gray.png') center/100% no-repeat;
                }
            }

            &:after {
                content: '';
                background: url('../../../assets/btn-unChecked_gray.png') center/100% no-repeat;
                width: 14px;
                height: 14px;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                right: unset;
                position: absolute;
            }
        }
    }

    .pickup-time {
        display: flex;
        justify-content: space-between;
        white-space: nowrap;

        &-trigger {
            background-color: #f1f1f1;
            min-width: 1.5rem;
            height: 0.48rem;
            padding: 0 0.1rem;
            text-align: center;
            margin-left: 0.1rem;
        }
    }

    .goods-number {
        height: 100%;
        line-height: 0.33rem;
        width: 2rem;
        padding: 0;
        margin: 0;
        outline: none;
        border: 0;
        text-align: right;
        color: #4f4f4f;
        background-color: rgb(177, 207, 255);

        &::-webkit-input-placeholder {
            color: #8f8f8f;
        }
    }

    .selector {
        padding-right: 0.4rem;
        position: relative;

        &-arrow {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
        }
    }

    .btn-box {
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: flex-end;

        .edit-btn {
            background: url('../../../assets/edit.png') center/100% no-repeat;
            width: 0.48rem;
            height: 0.53rem;
        }

        .del-btn {
            background: url('../../../assets/del.png') center/100% no-repeat;
            width: 0.44rem;
            height: 0.48rem;
            margin: 0 1.17rem 0 1.47rem;
        }
    }

    .send-address-card__active {
        .card-row {
            & ~ .card-row {
                &:before {
                    border-top: 1px solid #fff;
                }
            }

            .card-col {
                &.f-row {
                }

                & ~ .card-col {
                    &:before {
                        border-left: 1px solid #fff;
                    }
                }
            }
        }

    }

    .cus-field-search {
        height: 1.333333rem;
    }

    .btn-box-affirm {
        margin-top: .4rem;
        margin-left: 0.27rem;
        width: 9.47rem;
        height: 1.68rem;
        background: #fff;
        border-top: 1px solid #e5e5e5;
        box-sizing: border-box;
        padding: .36rem 0.36rem ;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        overflow: hidden;

        .btn {
            width: 4rem;
        }
    }
</style>
